import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { catchError, map, switchMap } from 'rxjs/operators';
import { IFile } from '@shared/interfaces/file';
import { U2bFilesApiService } from '@core/services/api/u2b-files.api-service';

@Component({
    selector: 'u2b-secured-image-u2b',
    styles: [`
        img {
            width: 100%;
        }
        .image-loader {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
        }
    `],
    template: `
        <ng-container *ngIf="dataUrl; else imageLoader">
            <img class="{{class}}"
                 alt=""
                 [class.is-placeholder]="isPlaceholder"
                 [class.is-real-image]="!isPlaceholder"
                 [src]="dataUrl"/>
        </ng-container>
        <ng-template #imageLoader>
            <div class="image-loader">
                <mat-spinner mode="indeterminate" [diameter]="20"></mat-spinner>
            </div>
        </ng-template>
    `,
    standalone: false
})
export class SecuredImageU2bComponent implements OnChanges {

    @Input() public class: string;

    @Input() public file: IFile;

    @Input() public placeholder = 'assets/images/placeholder/default.jpg';

    @Input() public tempUrl: SafeUrl;

    private src$: BehaviorSubject<IFile>;

    public dataUrl: SafeUrl;

    public isPlaceholder = true;

    constructor(
        private _u2bFilesApiService: U2bFilesApiService,
        private domSanitizer: DomSanitizer,
        cdr: ChangeDetectorRef,
    ) {
        this.src$ = new BehaviorSubject(this.file);
        this.src$
            .pipe(switchMap((file: IFile) => this.loadImage(file)))
            .subscribe((url: SafeUrl) => {
                this.dataUrl = url;
                cdr.markForCheck();
            });
    }

    ngOnChanges(): void {
        if (this.tempUrl) {
            this.src$.next(null);
            return;
        }
        this.src$.next(this.file);
    }

    private loadImage(file: IFile): Observable<SafeUrl> {
        if (!file?.id) {
            this.isPlaceholder = true;
            return of(this.tempUrl || this.placeholder);
        }

        return this._u2bFilesApiService.getById(file.id)
            .pipe(
                map((blob: Blob) => {
                    this.isPlaceholder = false;
                    return this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
                }),
                catchError(() => {
                    this.isPlaceholder = true;
                    return of(this.tempUrl || this.placeholder);
                }),
            );
    }
}
